var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import cls from 'classnames';
import { ListItem, List, tools } from 'rcm-mobile';
import './style/index.scss';
/**
 * @author sayll
 * @version 0.0.1
 */
export default class Panel extends React.PureComponent {
    constructor(props) {
        super(props);
        this.refPanelBody = React.createRef();
        this.handleClick = (e) => {
            const collapsed = !this.state.collapsed;
            const { onClick, collapsable } = this.props;
            if (collapsable) {
                this.setState({ collapsed });
            }
            onClick && onClick(e);
        };
        // 存在一个默认
        this.handleToggleCollapse = (hasAnimation = true) => {
            const { onCollapseChange } = this.props;
            // @ts-ignore
            tools.dom.toggle(this.refPanelBody.current, hasAnimation ? 'height' : '');
            hasAnimation && onCollapseChange && onCollapseChange(this.state.collapsed, this);
        };
        this.state = {
            style: {},
            collapsed: props.collapsed,
            propsCollapsed: props.collapsed
        };
    }
    render() {
        const { collapsed } = this.state;
        const _a = this.props, { prefixCls, className, collapsed: _collapsed, collapsable, title, children, onClick, onCollapseChange } = _a, resetProps = __rest(_a, ["prefixCls", "className", "collapsed", "collapsable", "title", "children", "onClick", "onCollapseChange"]);
        const classNames = cls(prefixCls, className, {
            [`${prefixCls}-collapsed`]: this.state.collapsed
        });
        return (<List {...resetProps} className={classNames}>
        <ListItem className={`${prefixCls}-title`} title={title} arrow={collapsed ? 'right' : 'bottom'} onClick={this.handleClick}/>
        <div ref={this.refPanelBody} className={`${prefixCls}-body`}>{children}</div>
      </List>);
    }
    componentDidMount() {
        if (this.state.collapsed) {
            this.handleToggleCollapse(false);
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        // 副本比较 及 内部状态比较
        if (nextProps.collapsed !== prevState.collapsed && nextProps.collapsed !== prevState.propsCollapsed) {
            return {
                collapsed: nextProps.collapsed,
                propsCollapsed: nextProps.collapsed
            };
        }
        return null;
    }
    // @ts-ignore
    getSnapshotBeforeUpdate(prevProps, prevState) {
        if (prevState.collapsed !== this.state.collapsed) {
            this.handleToggleCollapse();
        }
        return null;
    }
    set collapsed(collapsed) {
        this.setState({ collapsed });
    }
}
Panel.defaultProps = {
    prefixCls: 'x-panel',
    collapsed: true,
    collapsable: true
};
